import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-585c1928"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-section keys" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { width: "25%" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Location"),
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Floor"),
    /*#__PURE__*/_createElementVNode("th", { width: "25%" }, "Condition"),
    /*#__PURE__*/_createElementVNode("th", { width: "10%" }, "Expiry date"),
    /*#__PURE__*/_createElementVNode("th", { width: "5%" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions")
    ])
  ])
], -1))
const _hoisted_4 = ["onUpdate:modelValue", "onChange"]
const _hoisted_5 = ["onUpdate:modelValue", "onChange"]
const _hoisted_6 = ["onUpdate:modelValue", "onChange"]
const _hoisted_7 = ["onUpdate:modelValue", "onChange"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "no-border" }
const _hoisted_12 = {
  colspan: "4",
  class: "text-right no-border"
}
const _hoisted_13 = { class: "btn-group" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))

import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import Photos from "@/components/photo/Photos.vue";
import { DxDateBox } from "devextreme-vue/date-box";
import { Alarm, Photo, Report } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'Alarms',
  setup(__props) {

const store = useStore();
const actProperty: any = inject('actProperty');

const statereport = computed<Report>(() => store.getters['reports/current']);

const setReportDeep = (payload: { path: string; data: any }) => {
  store.dispatch('reports/setReportDeep', payload);
};

const conditions = ref<string[]>([
  "Expiry date not seen",
  "Expiry date seen but not legible",
]);

const alarms = computed<Alarm[]>({
  get: () => statereport.value.alarms,
  set: (data) => {
    setReportDeep({ path: "alarms", data });
  }
});

const addNewAlarm = () => {
  alarms.value = [...alarms.value, new Alarm()];
};

const removeAlarm = async (index: number) => {
  actProperty
      .confirmPrompt()
      .then(() => alarms.value = actProperty.removeItemByIndex(alarms.value, index));
};

const toggleCondition = (condition: string, index: number) => {
  const alarm: Alarm = alarms.value[index];
  if (alarm) {
    const path = `alarms[${index}].expirydatecondition`;
    const data = alarm.expirydatecondition === condition ? '' : condition;
    setReportDeep({ path, data });
  }
};

const expiryDateSelected = (alarm: Alarm, index: number) => {
  if (alarm.edate) {
    setReportDeep({
      path: `alarms[${index}].expirydatecondition`,
      data: "",
    });
  }
};
const editAlarms = (alarm:Alarm,index:Number) => {
 setReportDeep({
    path: `alarms[${index}]`,
    data:alarm
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alarms.value, (alarm, $index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `row${alarm._uuid}`
          }, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((alarm.name) = $event),
                  class: "form-control form-control-sm",
                  size: "5",
                  onChange: ($event: any) => (editAlarms(alarm,$index))
                }, null, 40, _hoisted_4), [
                  [
                    _vModelText,
                    alarm.name,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((alarm.location) = $event),
                  class: "form-control form-control-sm",
                  size: "5",
                  onChange: ($event: any) => (editAlarms(alarm,$index))
                }, null, 40, _hoisted_5), [
                  [
                    _vModelText,
                    alarm.location,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((alarm.floor) = $event),
                  class: "form-control form-control-sm",
                  size: "2",
                  onChange: ($event: any) => (editAlarms(alarm,$index))
                }, null, 40, _hoisted_6), [
                  [
                    _vModelText,
                    alarm.floor,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((alarm.condition) = $event),
                  class: "form-control form-control-sm",
                  size: "10",
                  onChange: ($event: any) => (editAlarms(alarm,$index))
                }, null, 40, _hoisted_7), [
                  [
                    _vModelText,
                    alarm.condition,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_unref(DxDateBox), {
                  modelValue: alarm.edate,
                  "onUpdate:modelValue": ($event: any) => ((alarm.edate) = $event),
                  "display-format": "MMM yyyy",
                  type: "date",
                  "picker-type": "calendar",
                  "apply-value-mode": "instantly",
                  onValueChanged: ($event: any) => (expiryDateSelected(alarm, $index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onValueChanged"])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-outline-danger",
                  onClick: ($event: any) => (removeAlarm($index)),
                  tabindex: "-1"
                }, _hoisted_10, 8, _hoisted_8)
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_11, [
                (_openBlock(), _createBlock(Photos, {
                  key: `row${alarm._uuid}${alarm.photos.length}`,
                  photos: alarm.photos,
                  path: `alarms[${$index}].photos`
                }, null, 8, ["photos", "path"]))
              ]),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conditions.value, (condition) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass(["btn conditionbutton", {
                    'btn-primary': alarm.expirydatecondition === condition,
                    'btn-light': alarm.expirydatecondition != condition,
                  }]),
                      key: condition,
                      onClick: ($event: any) => (toggleCondition(condition, $index))
                    }, _toDisplayString(condition), 11, _hoisted_14))
                  }), 128))
                ])
              ])
            ])
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addNewAlarm()))
    }, [
      _hoisted_15,
      _createTextVNode(" Alarm ")
    ])
  ]))
}
}

})